function Rxw({ children, className }) {
  return <div className={`d-flex flex-row ${className}`}>{children}</div>;
}

export default Rxw;
